module.exports = __webpack_public_path__ + "img/ic_map_location.f615b7f6.svg";